import React from 'react'
import styles from './Style.module.css'

const Placeholder = ({
    heading,
    para,
    icon,
    contentClassName = ''
}) => {
  return (
    <div className={styles.Placeholder}>
        <div className={styles.icon}>
            {icon}
        </div>
        <div className={`${styles.content} ${contentClassName}`}>
            <h6>{heading}</h6>
            <p>{para}</p>
        </div>
    </div>
  )
}

export default Placeholder